import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  IconButton
} from "@material-ui/core";
import { refreshCache } from "../../Admin/services/admin";
import { notify } from "../../../toasts/toasts";
import Frame from "../../Admin/Components/Frame/Frame";
import { mainStyles } from "../../mainStyles";
import "./Other.scss";

const useStyles = mainStyles;

const Other = () => {
  const classes = useStyles();
  const [authProvider] = useState('AWSCognito');
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const handleRefreshCache = async () => {
    if (isRefreshing) return;
    
    setIsRefreshing(true);
    try {
      await refreshCache(authProvider);
    } catch (error) {
      console.error("Error refreshing cache:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const innerFrame = (
    <div className={classes.root}>
      <Container maxWidth="lg" className={classes.container + ` other-container`}>
        <Grid container spacing={3} className="other-container-body">
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Box p={3}>
                <Typography variant="h5" component="h2" gutterBottom>
                  Other Admin Functions
                </Typography>
                <Typography variant="body1" paragraph>
                  This section contains administrative functions and utilities.
                </Typography>
                
                <Box mt={3}>
                  <Typography variant="h6" component="h3" gutterBottom>
                    Cache Management
                  </Typography>
                  <Typography variant="body2" paragraph>
                    Refresh the application cache to ensure users receive the latest data.
                  </Typography>
                  <IconButton
                    aria-label="refresh-cache"
                    size="small"
                    className="text-button add refresh-cache-button"
                    onClick={handleRefreshCache}
                    disabled={isRefreshing}
                  >
                    {isRefreshing ? "Refreshing..." : "Refresh Cache"}
                  </IconButton>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );

  return <Frame className="other-container" innerFrame={innerFrame}></Frame>;
};

export default Other;
